import React, { useMemo, useState } from "react";
import { base_url, getToken } from "../config/config";

const GoogleSheet = () => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [status, setStatus] = useState("");
  const [refreshKey, setRefreshKey] = useState(Date.now());

  const sheetUrl = useMemo(
    () =>
      `https://docs.google.com/spreadsheets/d/e/2PACX-1vQlVG0qih_TXRWz1Q_tNmdoyOATMKr--50q96O8Ri3bU9iUYswrMx3x1189VwUBkHrNWI7_3waIaDDt/pubhtml?refresh=${refreshKey}`,
    [refreshKey],
  );

  const handleSyncNachkalkulation2026 = async () => {
    setIsSyncing(true);
    setStatus("Nachkalkulation 2026 sync in progress...");
    console.log("BASE_url", base_url);
    try {
      const token = getToken();
      const endpointCandidates = [
        `${base_url}/v1/GetNachkalkulation2026Data`,
        `${base_url}/GetNachkalkulation2026Data`,
      ];

      let response = null;
      let responseData = null;

      for (const endpoint of endpointCandidates) {
        const apiResponse = await fetch(endpoint, {
          method: "POST",
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        const parsed = await apiResponse
          .json()
          .catch(() => ({ message: "Invalid JSON response from server." }));

        if (apiResponse.status === 404) {
          continue;
        }

        response = apiResponse;
        responseData = parsed;
        break;
      }

      if (!response) {
        throw new Error("GetNachkalkulation2026Data endpoint not found.");
      }

      if (!response.ok) {
        throw new Error(
          responseData?.message || `Sync failed with status ${response.status}`,
        );
      }

      const rows = Array.isArray(responseData?.data) ? responseData.data : [];

      if (responseData?.updated === true && rows.length === 0) {
        setStatus("Nachkalkulation 2026 is already up to date.");
      } else {
        setStatus(
          `Nachkalkulation 2026 synced successfully. ${rows.length} row(s) processed.`,
        );
      }

      setRefreshKey(Date.now());
    } catch (error) {
      setStatus(error?.message || "Failed to sync Nachkalkulation 2026.");
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "12px",
        }}
      >
        <button
          type="button"
          onClick={handleSyncNachkalkulation2026}
          disabled={isSyncing}
          style={{
            padding: "8px 14px",
            borderRadius: "6px",
            border: "1px solid #1f4a8a",
            background: isSyncing ? "#9bb4d6" : "#1f4a8a",
            color: "#fff",
            cursor: isSyncing ? "not-allowed" : "pointer",
          }}
        >
          {isSyncing
            ? "Syncing Nachkalkulation 2026..."
            : "Update Nachkalkulation 2026"}
        </button>
        {status && <span style={{ fontSize: "14px" }}>{status}</span>}
      </div>

      <div style={{ width: "100%", height: "600px" }}>
        <iframe
          title="Google Sheet"
          src={sheetUrl}
          width="100%"
          height="100%"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default GoogleSheet;
